var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrimarymoderator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3081",
    "data-name": "Group 3081",
    transform: "translate(-247 -60)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_556",
    "data-name": "Path 556",
    transform: "translate(247 60)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 11 21.75 C 8.128569602966309 21.75 5.429009914398193 20.63179969787598 3.398600101470947 18.60140037536621 C 1.368199944496155 16.57098960876465 0.25 13.87143039703369 0.25 11 C 0.25 8.128569602966309 1.368199944496155 5.429009914398193 3.398600101470947 3.398600101470947 C 5.429009914398193 1.368199944496155 8.128569602966309 0.25 11 0.25 C 13.87143039703369 0.25 16.57098960876465 1.368199944496155 18.60140037536621 3.398600101470947 C 20.63179969787598 5.429009914398193 21.75 8.128569602966309 21.75 11 C 21.75 13.87143039703369 20.63179969787598 16.57098960876465 18.60140037536621 18.60140037536621 C 16.57098960876465 20.63179969787598 13.87143039703369 21.75 11 21.75 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11 0.5 C 5.21027946472168 0.5 0.5 5.21027946472168 0.5 11 C 0.5 16.78972053527832 5.21027946472168 21.5 11 21.5 C 16.78972053527832 21.5 21.5 16.78972053527832 21.5 11 C 21.5 5.21027946472168 16.78972053527832 0.5 11 0.5 M 11 0 C 17.07513046264648 0 22 4.924869537353516 22 11 C 22 17.07513046264648 17.07513046264648 22 11 22 C 4.924869537353516 22 0 17.07513046264648 0 11 C 0 4.924869537353516 4.924869537353516 0 11 0 Z",
    stroke: "none",
    fill: "#878485"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1477",
    "data-name": "Group 1477",
    transform: "translate(250.504 65.606)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M128.157,13.293a1.584,1.584,0,0,1-.347-.678,1.4,1.4,0,0,1,2.7-.718,1.065,1.065,0,0,0,.065.228v.4a3.4,3.4,0,0,1-.142.421,1.414,1.414,0,0,1-.849.727l-.11.035a.4.4,0,0,0-.089.007,1.381,1.381,0,0,1-.559-.024A1.49,1.49,0,0,1,128.157,13.293Z",
    transform: "translate(-115.862 -9.848)",
    fill: "#fec031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M83.874,26.671a1.49,1.49,0,0,0,.678.393,1.381,1.381,0,0,0,.559.024.409.409,0,0,0,.089-.007c-.064.491-.141.98-.248,1.463a7.681,7.681,0,0,1-.868,2.341.155.155,0,0,1-.023.027H78.93V26.028a1.392,1.392,0,0,0,1-.418,1.876,1.876,0,0,0,.348.838,2.168,2.168,0,0,0,1.188.875,2.248,2.248,0,0,0,2.087-.358A2.1,2.1,0,0,0,83.874,26.671Z",
    transform: "translate(-71.578 -23.226)",
    fill: "#fcf286"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M18.087,26.382v4.88H12.964a6.564,6.564,0,0,1-.706-1.655,11.445,11.445,0,0,1-.279-1.191c-.061-.325-.1-.652-.148-.982a.709.709,0,0,1,.093,0,1.423,1.423,0,0,0,.807-.116,2.051,2.051,0,0,0,.42-.293,2.2,2.2,0,0,0,1.025.652,2.249,2.249,0,0,0,2.248-.514A2.282,2.282,0,0,0,17.1,26a.117.117,0,0,1,.075.041,1.4,1.4,0,0,0,.9.337Z",
    transform: "translate(-10.729 -23.58)",
    fill: "#febf2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M23.893,83h5.122v2.236a.151.151,0,0,0,.027.11c-.025.044-.061.031-.093.031H24.376c-.3,0-.485-.255-.486-.652C23.887,84.143,23.891,83.57,23.893,83Z",
    transform: "translate(-21.665 -75.27)",
    fill: "#faa741"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M78.906,85.436c-.031-.027-.027-.069-.027-.11V83.09H84v1.78c0,.326-.175.559-.415.566-.332.006-.664,0-1,0H79.013A.586.586,0,0,1,78.906,85.436Z",
    transform: "translate(-71.532 -75.352)",
    fill: "#fec030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M2.432,13.982a2.554,2.554,0,0,1-.43.3,1.423,1.423,0,0,1-.807.116.71.71,0,0,0-.093,0,1.94,1.94,0,0,1-.546-.262,1.4,1.4,0,0,1-.5-1.464,1.349,1.349,0,0,1,1.129-1.033,1.381,1.381,0,0,1,1.584,1.053,1.366,1.366,0,0,1-.279,1.22C2.469,13.935,2.453,13.96,2.432,13.982Z",
    transform: "translate(-0.011 -10.538)",
    fill: "#faa741"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M79.993,2.428A1.392,1.392,0,0,1,79,2.847V.047a1.35,1.35,0,0,1,1.17.632A1.384,1.384,0,0,1,80.109,2.3C80.074,2.344,80.016,2.372,79.993,2.428Z",
    transform: "translate(-71.642 -0.045)",
    fill: "#fec031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M65.3.026V2.82a1.4,1.4,0,0,1-.9-.337c-.022-.019-.042-.043-.075-.041a1.077,1.077,0,0,0-.146-.192,1.363,1.363,0,0,1-.27-.932A1.4,1.4,0,0,1,64.822.108,1.025,1.025,0,0,1,65.3.026Z",
    transform: "translate(-57.95 -0.023)",
    fill: "#faa741"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimarymoderator);
export default __webpack_public_path__ + "static/media/primarymoderator.25f15635be18b823fb56ab06d7b97341.svg";
export { ForwardRef as ReactComponent };